import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.css";
import fr from "vuetify/es5/locale/fr";
import VuetifyGoogleAutocomplete from "../../../webapp-client/src/plugins/vga";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#60A694",
    secondary: "#b0bec5",
    accent: "#FF7C5D",
    error: "#b71c1c"
  },
  lang: {
    locales: { fr },
    current: "fr"
  }
});

Vue.use(VuetifyGoogleAutocomplete, {});
